import React, { FC, useState, createContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { templateConfigMap } from "./const/InitialCalcConfig";
import { ConfigItem } from "./types/requestTypes";

export interface IModalProps {
  msg: string;
  setMsg: (msg: string) => void;
}

export interface IRequestElement {
  isLoading: boolean;
  hasError: boolean;
}

export interface IRequestStatus {
  getCalculationRequest: IRequestElement;
}

export const TableResponseData = createContext<{
  calculationResult?: any;
  setcalculationResult?: any;
}>({});
export const ProductConfigContext = createContext<{
  productConfigEntry?: ConfigItem;
  setProductConfigEntry?: any;
}>({});
export const ConfigOptions = createContext({ templateConfigMap });

export const RequestStatusState = createContext<{
  requestsStatus?: IRequestStatus;
  setRequestsStatus?: any;
}>({});

export const App: FC = () => {
  const [calculationResult, setcalculationResult] = useState([]);
  const [requestsStatus, setRequestsStatus] = useState<IRequestStatus>({
    getCalculationRequest: {
      isLoading: false,
      hasError: false
    }
  });
  const [productConfigEntry, setProductConfigEntry] = useState<ConfigItem>();

  useEffect(() => {
    const resizeObserver = new ResizeObserver(entries => {
      window.parent.postMessage(entries[0].target.clientHeight, "*");
    });
    resizeObserver.observe(document.body);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <RequestStatusState.Provider value={{ requestsStatus, setRequestsStatus }}>
        <ProductConfigContext.Provider value={{ productConfigEntry, setProductConfigEntry }}>
          <TableResponseData.Provider value={{ calculationResult, setcalculationResult }}>
            <ConfigOptions.Provider value={{ templateConfigMap }}>
              <Routes>
                <Route path="/" element={<Home />} />
              </Routes>
            </ConfigOptions.Provider>
          </TableResponseData.Provider>
        </ProductConfigContext.Provider>
      </RequestStatusState.Provider>
    </>
  );
};
